import * as z from "zod";
import { ReturnAddressSchema } from "../return";

export const ApprovalProductInfoSchema = z.object({
  _id: z.string(),
  weight: z.number().optional(),
  weightUnit: z.string().optional(),
  shipBack: z.boolean().optional(),
  grams: z.number().optional(),
  hsCode: z.string().optional(),
});
export type ApprovalProductInfo = z.infer<typeof ApprovalProductInfoSchema>;

// The form's `id` is a symbol and does not survive serialization, so it is
// intentionally omitted — the server reconstructs shipment group ids by index.
export const ApprovalLabelSchema = z.object({
  items: z.array(z.object({ _id: z.string() }).passthrough()),
  weight: z.object({ amount: z.string(), unit: z.enum(["oz", "lbs", "g"]) }),
  returnToAddress: ReturnAddressSchema.optional(),
  labelNote: z.string().optional(),
});

/**
 * Everything the approve modal can send. Every field is optional so a bulk
 * run can approve with the flag alone and get the untouched-modal defaults.
 */
export const ApproveReturnFieldsSchema = z.object({
  customerNotes: z.string().optional(),
  customerImages: z.array(z.string()).optional(),
  orderTags: z.array(z.string()).optional(),
  products: z.array(ApprovalProductInfoSchema).optional(),
  selectedAddress: ReturnAddressSchema.optional(),
  multipleLabels: z.array(ApprovalLabelSchema).optional(),
  /** The merchant accepts fees caused by an incomplete customs declaration. */
  acknowledgeMissingCustoms: z.boolean().optional(),
});
export type ApproveReturnFields = z.infer<typeof ApproveReturnFieldsSchema>;
